import { defineStore } from 'pinia'

export const useGlobal = defineStore('global', {
  state: () => ({
    useInfo: null,
    prevIndex: null,
    doucmentType: null,
    refreshFlag: false,
    remoteMoved: false,
    stampImages: [],
    testFingerprintTimer: null,
    isNotReload: true,
    isToExternal: false,
    isToSealHistoryLen: 1
    // doucmentType: null,
    // sealBackUrl: null,
  }),
  actions: {
    setStampImages(val) {
      this.stampImages = val || []
    },
    setIsNotReload(val = false) {
      this.isNotReload = val
    }
  }
})
